import ProxiProvier from "../Proxi.Provider";

export default class ProxiCbGames extends ProxiProvier {
  constructor() {
    super();
    this.name = "CB GAMES "
  }
 
}